var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 723.276,
    height: 464.493,
    viewBox: "0 0 723.276 464.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ccc;}.b{fill:#e6e6e6;}.c{fill:#fff;}.d{fill:#3f3d56;}.e{fill:#2f2e41;}.f{fill:#6c63ff;}.g{fill:#44bba4;}.h{opacity:0.2;}.i{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-996.543 -4324.646)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M876.618,718.424H251.953a20.945,20.945,0,0,1-20.945-20.945h0q339.661-39.475,666.554,0h0A20.945,20.945,0,0,1,876.618,718.424Z",
    transform: "translate(808.902 4070.715)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M897.56,618.673l-666.552-1.232,77.251-129.984.37-.616V200.37a26.476,26.476,0,0,1,26.48-26.477h454.66a26.476,26.476,0,0,1,26.477,26.48v288.44Z",
    transform: "translate(808.902 4150.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M352.419,195.864a8.634,8.634,0,0,0-8.625,8.625v261.2a8.635,8.635,0,0,0,8.625,8.625H811.985a8.635,8.635,0,0,0,8.624-8.625v-261.2a8.634,8.634,0,0,0-8.625-8.625Z",
    transform: "translate(790.985 4147.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M352.446,567.913a3.706,3.706,0,0,0-3.358,2.151l-23.8,51.747a3.7,3.7,0,0,0,3.358,5.241H829.217a3.7,3.7,0,0,0,3.305-5.349l-25.874-51.747a3.677,3.677,0,0,0-3.305-2.043Z",
    transform: "translate(793.98 4088.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5.544,
    cy: 5.544,
    r: 5.544,
    transform: "translate(1365.795 4327.727)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M564.708,649.94a3.7,3.7,0,0,0-3.569,2.735l-5.971,22.177a3.7,3.7,0,0,0,3.569,4.658H672.29a3.7,3.7,0,0,0,3.492-4.905l-7.676-22.177a3.7,3.7,0,0,0-3.493-2.487Z",
    transform: "translate(757.428 4075.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M670.155,366.922v4.929H162.169l.382-.617v-4.313Z",
    transform: "translate(954.992 4266.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M851.782,554.237a.9.9,0,0,0-.869.666l-1.454,5.4a.9.9,0,0,0,.869,1.134H877.98a.9.9,0,0,0,.85-1.195l-1.869-5.4a.9.9,0,0,0-.851-.606Z",
    transform: "translate(710.664 4090.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M803.782,554.237a.9.9,0,0,0-.869.666l-1.454,5.4a.9.9,0,0,0,.869,1.134H829.98a.9.9,0,0,0,.85-1.195l-1.869-5.4a.9.9,0,0,0-.851-.606Z",
    transform: "translate(718.289 4090.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M653.974,540.325h2.167l-4.334-289.681H649.64l.086,5.779H601.152l.086-5.779h-2.167l-4.334,289.681H596.9l.281-18.782h56.507ZM650.85,331.552H600.029l.53-35.4h49.762Zm.032,2.167.53,35.4H599.466l.53-35.4Zm.562,37.565.53,35.4H598.9l.53-35.4Zm.562,37.565.53,35.4H598.342l.53-35.4Zm.562,37.565.53,35.4H597.78l.53-35.4Zm-2.81-187.823.53,35.4h-49.7l.53-35.4ZM597.218,519.375l.53-35.4h55.383l.53,35.4Z",
    transform: "translate(751.122 4138.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 35.339,
    cy: 35.339,
    r: 35.339,
    transform: "translate(1330.487 4418.305)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.736,
    height: 19.235,
    transform: "translate(1376.049 4479.979) rotate(-10.261)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.736,
    height: 19.235,
    transform: "translate(1354.921 4483.805) rotate(-10.261)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 8.946,
    cy: 3.355,
    rx: 8.946,
    ry: 3.355,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 1352.792, 4507.373)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 8.947,
    cy: 3.355,
    rx: 8.947,
    ry: 3.355,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 1373.48, 4503.629)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12.078,
    cy: 12.078,
    r: 12.078,
    transform: "translate(1351.274 4432.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.026,
    cy: 4.026,
    r: 4.026,
    transform: "translate(1354.362 4436.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M641.736,276.866c.531-13.083-10.744-24.164-25.185-24.751s-26.578,9.544-27.109,22.627,9.507,16.055,23.947,16.642S641.2,289.949,641.736,276.866Z",
    transform: "translate(751.967 4138.33)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.547,
    cy: 17.669,
    rx: 5.547,
    ry: 17.669,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 1314.732, 4448.662)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.547,
    cy: 17.669,
    rx: 5.547,
    ry: 17.669,
    transform: "matrix(0.223, -0.975, 0.975, 0.223, 1384.1, 4460.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M627,343.014a8.052,8.052,0,0,1-15.843,2.884l0-.016c-.792-4.376,2.591-5.924,6.967-6.716S626.206,338.638,627,343.014Z",
    transform: "translate(748.533 4124.555)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 18.113,
    cy: 5.686,
    rx: 18.113,
    ry: 5.686,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 1229.045, 4586.525)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 36.226,
    cy: 36.226,
    r: 36.226,
    transform: "translate(1165.78 4628.943) rotate(-80.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1190.833 4627.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1212.844 4627.42)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1190.832 4643.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1212.844 4643.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M388.181,454.278c-2.925-13.1,6.425-26.337,20.885-29.565s28.552,4.774,31.477,17.873-6.658,17.931-21.117,21.16S391.106,467.378,388.181,454.278Z",
    transform: "translate(784.02 4111.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.686,
    cy: 18.113,
    rx: 5.686,
    ry: 18.113,
    transform: "translate(1147.737 4579.557) rotate(-64.626)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 36.226,
    cy: 36.226,
    r: 36.226,
    transform: "translate(1014.259 4599.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1033.977 4664.102)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1055.988 4664.102)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1033.977 4680.609)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1055.988 4680.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12.381,
    cy: 12.381,
    r: 12.381,
    transform: "translate(1039.021 4614.119)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.127,
    cy: 4.127,
    r: 4.127,
    transform: "translate(1047.275 4622.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M201.7,497.885c-2.925-13.1,6.425-26.337,20.885-29.565s28.552,4.774,31.477,17.873-6.658,17.931-21.117,21.16S204.628,510.985,201.7,497.885Z",
    transform: "translate(813.642 4104.096)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 18.113,
    cy: 5.686,
    rx: 18.113,
    ry: 5.686,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, 1059.808, 4519.113)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 36.226,
    cy: 36.226,
    r: 36.226,
    transform: "translate(996.543 4561.533) rotate(-80.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1021.596 4560.008)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.005,
    height: 19.718,
    transform: "translate(1043.607 4560.008)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1021.596 4576.518)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1043.607 4576.059)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12.381,
    cy: 12.381,
    r: 12.381,
    transform: "translate(1026.64 4510.027)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.127,
    cy: 4.127,
    r: 4.127,
    transform: "translate(1034.894 4518.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M186.984,374.135c-2.925-13.1,6.425-26.337,20.885-29.565s28.552,4.774,31.477,17.873-6.658,17.931-21.117,21.16S189.909,387.235,186.984,374.135Z",
    transform: "translate(815.98 4123.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M207.707,434.612c0,3.546,9.129,10.547,19.259,10.547s19.628-9.982,19.628-13.527-9.5.688-19.628.688S207.707,431.066,207.707,434.612Z",
    transform: "translate(812.603 4110.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M270.727,255.461a2.526,2.526,0,0,0-2.523,2.523v104.3a2.526,2.526,0,0,0,2.523,2.523H512.137a2.526,2.526,0,0,0,2.523-2.523v-104.3a2.526,2.526,0,0,0-2.523-2.523Z",
    transform: "translate(802.993 4137.795)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 24.495,
    cy: 24.495,
    r: 24.495,
    transform: "translate(1114.409 4423.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.882,316.587a2.864,2.864,0,1,0,0,5.728h77.34a2.864,2.864,0,1,0,.094-5.728H413.882Z",
    transform: "translate(780.307 4128.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.882,296.86a2.864,2.864,0,1,0,0,5.728H452.5a2.864,2.864,0,1,0,.094-5.728H413.882Z",
    transform: "translate(780.307 4131.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M413.882,337.253a2.864,2.864,0,1,0,0,5.728h77.34a2.864,2.864,0,1,0,.094-5.728H413.882Z",
    transform: "translate(780.307 4124.803)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 5.686,
    cy: 18.113,
    rx: 5.686,
    ry: 18.113,
    transform: "matrix(0.934, -0.357, 0.357, 0.934, 1551.554, 4623.174)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 36.226,
    cy: 36.226,
    r: 36.226,
    transform: "translate(1547.688 4643.039) rotate(-9.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M740.957,447.932h-11l2.153,23.613,8.871-2.41Z",
    transform: "translate(864.798 4253.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M712.434,448.005H701.428l2.153,23.613,8.47-2.471Z",
    transform: "translate(869.33 4253.479)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1562.952 4720.016) rotate(-4.182)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 12.381,
    cy: 12.381,
    r: 12.381,
    transform: "translate(1575.95 4651.439)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.127,
    cy: 4.127,
    r: 4.127,
    transform: "translate(1584.204 4659.693)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 18.113,
    cy: 5.686,
    rx: 18.113,
    ry: 5.686,
    transform: "translate(1612.187 4658.965) rotate(-53.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M863.077,608.589c0-2.922,7.524-8.692,15.873-8.692s16.177,8.227,16.177,11.149-7.828-.567-16.177-.567S863.077,611.512,863.077,608.589Z",
    transform: "translate(708.496 4083.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M966.451,514.661l-198.3-27.49a5.9,5.9,0,0,1-5.024-6.641l22.292-160.8a5.9,5.9,0,0,1,6.641-5.024l198.3,27.49a5.9,5.9,0,0,1,5.024,6.641l-22.294,160.8a5.9,5.9,0,0,1-6.637,5.023Z",
    transform: "translate(724.382 4128.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M901.213,475.446,799.977,461.412a2.079,2.079,0,0,1-.374-.082l59.377-76.3a3.385,3.385,0,0,1,5.836.809l24.418,60.11,1.17,2.877Z",
    transform: "translate(718.579 4117.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M753.194,313.309l-34.564-4.791,20.384-22.294,1.468-1.606.733-.8,1.17,2.877Z",
    transform: "translate(866.597 4279.561)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M970.879,489.534,883.318,477.4,903.7,455.1l1.467-1.606,26.563-29.053a4.517,4.517,0,0,1,6.7.524,4.073,4.073,0,0,1,.263.441Z",
    transform: "translate(705.281 4111.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15.141,
    cy: 15.141,
    r: 15.141,
    transform: "translate(1605.882 4498.076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.505,
    height: 18.505,
    transform: "translate(1519.825 4455.459) rotate(7.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M915.878,542.254c2.925-13.1-6.425-26.337-20.885-29.565s-28.552,4.774-31.477,17.873,6.658,17.931,21.117,21.16S912.953,555.354,915.878,542.254Z",
    transform: "translate(708.51 4097.047)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 9.171,
    cy: 3.439,
    rx: 9.171,
    ry: 3.439,
    transform: "translate(1587.087 4719.957) rotate(-4.182)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup7);
export default __webpack_public_path__ + "static/media/sup7.6fea0b0c93acb027e22222e0b493e516.svg";
export { ForwardRef as ReactComponent };